export default "/images/type.svg?8c4d1dd13ffebf65700faf676f22ed9a";